import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

interface Props {
  onPaymentSuccess: (paymentIntentId: string) => Promise<void>;
  onPaymentError: (msg: string) => void;
  amountUsd: number;
  disabled?: boolean;
  // 카드 청구 전에 배송지 등 사전 검증. false면 결제를 진행하지 않는다.
  onBeforePay?: () => boolean;
}

const StripePaymentForm: React.FC<Props> = ({
  onPaymentSuccess,
  onPaymentError,
  amountUsd,
  disabled,
  onBeforePay,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!stripe || !elements) return;
    if (onBeforePay && !onBeforePay()) return;
    setSubmitting(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (error) {
      onPaymentError(error.message || '결제 실패');
      setSubmitting(false);
      return;
    }
    if (paymentIntent && paymentIntent.status === 'succeeded') {
      try {
        await onPaymentSuccess(paymentIntent.id);
      } catch (err: any) {
        onPaymentError(err.message || '주문 생성 실패');
      }
    }
    setSubmitting(false);
  };

  return (
    // 바깥 CheckoutPage가 <form>으로 감싸므로 여기서 <form>을 쓰면 폼 중첩으로
    // 결제 버튼이 네이티브 제출을 일으킨다. type="button" + onClick으로 처리한다.
    <div>
      <PaymentElement />
      <button
        type="button"
        onClick={handleSubmit}
        disabled={!stripe || disabled || submitting}
        style={s.payBtn}
      >
        {submitting ? '결제 처리 중...' : `$${amountUsd.toFixed(2)} 결제하기`}
      </button>
    </div>
  );
};

const s: Record<string, React.CSSProperties> = {
  payBtn: {
    width: '100%', padding: '14px', background: '#635bff',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 16,
  },
};

export default StripePaymentForm;
